import ape from '../../public/images/ape.jpg';
import beeEater from '../../public/images/bee-eater.jpg';
import elephant from '../../public/images/elephant.jpg';
import flamingo from '../../public/images/flamingo.jpg';
import frog from '../../public/images/frog.jpg';
import pelican from '../../public/images/pelican.jpg';
import rhino from '../../public/images/rhino.jpg';
import shark from '../../public/images/shark.jpg';
import tiger from '../../public/images/tiger.jpg';
import zebra from '../../public/images/zebra.jpg';

const images = [ape, beeEater, elephant, flamingo, frog,
  pelican, rhino, shark, tiger, zebra];

export default images;
